export function ucfirst(str) {
  return str[0].toUpperCase() + str.slice(1)
}

export function ucwords(str) {
  return str.replace(/\b(\w+)/, (match, word) => ucfirst(word))
}
